import React from "react"
import PropTypes from "prop-types"

import Col from "react-bootstrap/lib/Col"
import Row from "react-bootstrap/lib/Row"

import FirstSlot from "../../DeliveryInfo/FirstSlot"

// @ts-ignore
import style from "./index.module.sass"
import {Venue} from "../../../../types/venue";
import {OrderModeType} from "../../../../types/orders";
import VenueBadges from "./VenueBadges/VenueBadges";

type Props = {
    venue: Venue,
    onClick: (event: any, venue: Venue) => void,
    orderMode: OrderModeType,
    isVisible?: boolean,
}

// @ts-ignore
const I18n = window.I18n

export default function VenueBox(props : Props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const { venue, onClick, orderMode, isVisible = true } = props

  const {
    name,
    subtitle,
    coming_soon_at,
    first_time_slot,
    logo,
    cover_image,
    distance,
    promotion,
    accepts_cash,
    accepts_stripe,
    accepts_discount_codes,
  } = venue

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  function humanDistance(distance : number) {
    const roundedDistance = parseFloat(distance.toFixed(1))

    if (roundedDistance < 1) {
      return ` ${roundedDistance * 1000.0} m`
    } else {
      return ` ${roundedDistance} km`
    }
  }

  function renderVenueFeatures() {
    let features = []
    if (accepts_cash) {
      features.push(I18n.t("pages.locations.venues.venue_box.payments.cash"))
    }
    if (accepts_stripe) {
      features.push(
        I18n.t("pages.locations.venues.venue_box.payments.credit_card")
      )
    }
    if (!accepts_discount_codes) {
      features.push(
        I18n.t("pages.locations.venues.venue_box.payments.no_coupon")
      )
    }

    return <div className={style.venueBoxDetails}>{features.join(" • ")}</div>
  }

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  const comingSoon = coming_soon_at && new Date(coming_soon_at)
  const isFarAway =
    comingSoon &&
    comingSoon.getTime() - new Date().getTime() >
      1000 /*ms*/ *
        60 /*s*/ *
        60 /*min*/ *
        24 /*h*/ *
        30 /*days*/ *
        6 /*months*/

  // -------------------------------------

  return (
    <div
      data-test-id={`venue-box-${venue.id}`}
      className={style.venueCard}
      onClick={(event) => onClick(event, venue)}
    >
      <div className={style.coverImageContainer}>
        <div
          className={`${style.coverImage} ${!first_time_slot && !comingSoon ? style.greyCover : "" }`}
          style={
            isVisible ? { backgroundImage: "url('" + cover_image + "')" } : {}
          }
        >
          {(!first_time_slot || comingSoon) && <div className={style.coverImageDisabled} />}
          {!!comingSoon && (
            <p className={`fr-p2 fr-normal fr-white ${style.comingSoon}`}>
              {isFarAway
                ? I18n.t("pages.locations.venues.venue_box.coming_at_future")
                : I18n.t("pages.locations.venues.venue_box.coming_at", {
                    date: comingSoon.toLocaleString(I18n.locale, {
                      day: "2-digit",
                      month: "long",
                      year: "numeric",
                    }),
                  })}
            </p>
          )}
          {!comingSoon && !first_time_slot && (
            <p className={`fr-p2 fr-normal fr-white ${style.comingSoon}`}>
              {I18n.t("pages.locations.venues.venue_box.ended_deliveries")}
            </p>
          )}
        </div>
      </div>

      <div className={style.venueBoxLogo}>
        {isVisible && <img src={logo} alt={`${venue.name} logo`} />}
      </div>

      {!!first_time_slot && (
        <div className={style.venueBoxTimeContainer}>
          <div className={style.venueBoxTime}>
            {/* {coming_soon_at && <ComingSoon sDate={coming_soon_at} />} */}
            <FirstSlot orderMode={orderMode} slot={first_time_slot} />
          </div>
        </div>
      )}

      <div className={style.venueBoxBody}>
        <VenueBadges venue={venue} />

        <h3 className={style.venueBoxName}>
          {name}
          {distance && <span className="small">{humanDistance(distance)}</span>}
        </h3>
        <div className={style.venueBoxSubtitle}>{subtitle}</div>
        <Row>
          <Col xs={12}>{renderVenueFeatures()}</Col>
        </Row>

        {promotion && (
          <Row>
            <Col xs={12}>
              <div className={style.venueBoxPromotion}>{promotion.title}</div>
            </Col>
          </Row>
        )}
      </div>
    </div>
  )
}
